var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/16/More") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/16/More",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,6.66666667 C3.26666667,6.66666667 2.66666667,7.26666667 2.66666667,8 C2.66666667,8.73333333 3.26666667,9.33333333 4,9.33333333 C4.73333333,9.33333333 5.33333333,8.73333333 5.33333333,8 C5.33333333,7.26666667 4.73333333,6.66666667 4,6.66666667 Z M12,6.66666667 C11.2666667,6.66666667 10.6666667,7.26666667 10.6666667,8 C10.6666667,8.73333333 11.2666667,9.33333333 12,9.33333333 C12.7333333,9.33333333 13.3333333,8.73333333 13.3333333,8 C13.3333333,7.26666667 12.7333333,6.66666667 12,6.66666667 Z M8,6.66666667 C7.26666667,6.66666667 6.66666667,7.26666667 6.66666667,8 C6.66666667,8.73333333 7.26666667,9.33333333 8,9.33333333 C8.73333333,9.33333333 9.33333333,8.73333333 9.33333333,8 C9.33333333,7.26666667 8.73333333,6.66666667 8,6.66666667 Z",
    id: "Style"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.debe04ae670749760cff7847ff9f8b81.svg";
export { ForwardRef as ReactComponent };